import { Component } from '@angular/core';
import { first } from 'rxjs/operators';

import { CheckoutService } from '../../../../checkout/checkout.service';
import { ExchangeCarService } from '../../../../exchange-car/exchange-car.service';
import { SidePanelService } from '../../../../side-panel/side-panel.service';

@Component({
    selector: 'app-checkout-step-exchange-car',
    template: `
        <section class="flow-step">
            <section class="flow-step__header">
                <h1 class="h4">
                    {{ 'checkout.exchange_car_step____headline' | translate }}
                </h1>
                <p>{{ 'checkout.exchange_car_step____description' | translate }}</p>
            </section>
            <section class="flow-step__content" *ngIf="checkoutService.getCheckoutData() | async as cd">
                <!-- <app-fade-in> -->
                    <section class="flow-step__header animate-fade-in">
                        <app-button
                            (handleClick)="setHasExchangeCar(true); handleIndicataClick()"
                            [buttonClass]="'button--primary button--has-spacing'"
                            [title]="'checkout.exchange_car_step____button_option____yes' | translate"
                        ></app-button>
                        <app-button
                            (handleClick)="setHasExchangeCar(false); checkoutService.removeExchangeCar()"
                            [buttonClass]="'button--tertiary button--has-spacing'"
                            [loading]="!!(checkoutService.isCheckoutLoading$ | async) && !hasExchangeCar"
                            [title]="'checkout.exchange_car_step____button_option____no' | translate"
                        ></app-button>
                    </section>
                <!-- </app-fade-in> -->
                <ng-container *ngIf="exchangeCarService.exchangeCars | async as exchangeCars">
                    <app-checkout-step-exchange-car-list
                        *ngIf="exchangeCars.length && (hasExchangeCar || cd.exchangeCar)"
                        class="animate-fade-in">
                    </app-checkout-step-exchange-car-list>
                </ng-container>
            </section>
        </section>
    `,
})
export class CheckoutStepExchangeCarComponent {
    hasExchangeCar?: boolean;
    constructor(public checkoutService: CheckoutService,
        public exchangeCarService: ExchangeCarService,
        private sidepanelService: SidePanelService) {}

    setHasExchangeCar(val: boolean) {
        this.hasExchangeCar = val;
    }

    handleIndicataClick() {
        this.exchangeCarService.exchangeCars.pipe(first()).subscribe((cars) => {
            if (!cars.length) {
                this.sidepanelService.showExhangeCarSidePanel();
            }
        });
    }
}
